import React from "react";
import CabTracker from "../../components/cabTrackView/cabTracker";
import less from "./cabTrack.module.scss";

// Public page: /cab-track/:cabBookingGroupId
// Opened from the operator dashboard and the marshal app (webview)
const CabTrack = ({ match }) => (
  <div className={less.page}>
    <div className={less.header}>Track Cab</div>
    <div className={less.body}>
      <CabTracker cabBookingGroupId={match.params.cabBookingGroupId} />
    </div>
  </div>
);

export default CabTrack;
